// BNB Address
const BNB_ADDRESS = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c'
const DXD_ADDRESS = '0x4d97697f098457fa17ebc4f7402a3b6ab8f9a931'

export { BNB_ADDRESS, DXD_ADDRESS }
